import Transformer from './transformer';
// import stringUtil from '../utils/stringUtil';
import numberUtil from '../utils/number';
import dateUtil from '../utils/dateTime';
import timeSlotUtil from '../utils/timeSlot';
import moment from 'moment-timezone';
import { capitalize } from 'lodash';

export default class CouponTransformer extends Transformer {
  static fetch(coupon) {
    return {
      id: coupon.id,
      code: coupon.coupon_code,
      discount_percent: coupon.discount_percent,
      discount_money: coupon.discount_money,
      provider_cut_percent: coupon.provider_cut_percent,
      provider_cut_money: coupon.provider_cut_money,
      country: coupon.country,
      status: coupon.status,
      coupon_referrer_id: coupon.coupon_referrer_id,
      referrer_cut_percent: coupon.referrer_cut_percent,
      referrer_cut_money: coupon.referrer_cut_money,
      expire: coupon.expire,
      limit: coupon.limit,
      create_by: coupon.user,
      created: coupon.created,
      coupon_id: coupon.coupon_id,
      total_usage: coupon.total_usage,
    };
  }

  static fetchForTable(coupon) {
    return {
      id: coupon.id,
      code: coupon.code,
      description: coupon.description,
      meta: coupon.meta,
      created_at: dateUtil.formateDateTimeForDisplay(coupon.created_at),
      created_by: coupon.user,
      status: capitalize(coupon.status),
      coupon_id: coupon.coupon_id,
      type: coupon.type,
      total_usage: coupon.total_usage,
    };
  }

  static formatMetaTable(couponList) {
    return couponList.map((coupon, index) => ({
      _id: index,
      id: coupon.id,
      coupon_id: coupon.coupon_id,
      total_usage: coupon.total_usage,
      total_usage_limit: coupon.total_usage_limit,
      individual_usage_limit: coupon.individual_usage_limit,
      discount_amount: coupon.discount_amount,
      discount_limit: coupon.discount_limit,
      discount_unit: coupon.discount_unit,
      currency: coupon.currency,
      terms_link_url: coupon.terms_link_url,
      refresh_quota: coupon.refresh_quota,
      promotion_start_at: dateUtil.formateDateTimeForDisplay(coupon.promotion_start_at),
      promotion_end_at: dateUtil.formateDateTimeForDisplay(coupon.promotion_end_at),
      deleted_at: dateUtil.formateDateTimeForDisplay(coupon.deleted_at),
      created_at: dateUtil.formateDateTimeForDisplay(coupon.created_at),
      updated_at: dateUtil.formateDateTimeForDisplay(coupon.updated_at),
    }));
  }

  static create(coupon) {
    const result = window._.cloneDeep(coupon);
    if (result.date) {
      result.expire = moment
        .tz(`${result.date} ${result.time}`, timeSlotUtil.getLocalTimeZone())
        .tz('UTC')
        .format('Y-MM-DD HH:mm:ss');
      delete result.date;
      delete result.time;
    }

    if (result.code) {
      result.quantity = 1;
      if (!result.limit) {
        result.limit = null;
      }
    } else {
      result.limit = 1;
      result.code = null;
    }
    return result;
  }

  static discount(coupon) {
    if (coupon.discount_percent) {
      return numberUtil.comma(coupon.discount_percent) + '%';
    } else if (coupon.discount_money) return numberUtil.comma(coupon.discount_money) + '฿';
    else return '-';
  }

  static providerCharge(coupon) {
    if (coupon.provider_cut_percent) {
      return numberUtil.comma(coupon.provider_cut_percent) + '%';
    } else if (coupon.provider_cut_money) return numberUtil.comma(coupon.provider_cut_money) + '฿';
    else return '-';
  }

  static limit(coupon) {
    if (coupon.limit) return coupon.limit;
    else return '∞';
  }
  static expire(coupon) {
    if (coupon.expire) return dateUtil.formatDateTimeFromTimeStamp(coupon.expire);
    else return 'No Expire';
  }
}

export const couponMixin = {
  methods: {
    providerCharge: CouponTransformer.providerCharge,
    discount: CouponTransformer.discount,
  },
};
